// ResetPasswordForm.js
import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import appLogo from '../../assets/logo/app-logo.svg'
import { useDispatch } from 'react-redux'
// import { resetPassword } from '../../store/slice/authenticationSlice'
import { WelcomeText } from './Login'
import { useNavigate } from 'react-router-dom'
import Input from '../../components/input/Input'
import Button from '../../components/button/Button'
import Typography from '../../components/typography/Typography'
// import { Typography } from '@mui/material';
import validateField from '../../utility/validation'
import { setUserData } from '../../store/slice/auth/authenticationSlice'
import axios from 'axios'
import { toast } from 'react-toastify'
import { UI_CONSTANT } from '../../utility/constants'

function ResetPasswordForm() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [load,setLoad] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)

  const [tokenValid, setTokenValid] = useState(true)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({});
  const hasErrors = Object.values(errors).some((error) => error);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Validate the field value
    const error = validateField(name, value, formData);
    // Update the form data and errors state
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: error,
    });
  };

  function parseToken(token) {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid token format');
    }

    const payload = JSON.parse(atob(parts[1]));
    return payload;
  }

  useEffect(() => {
    if (token) {
      const { exp } = parseToken(token);
      const expirationTime = exp * 1000;
      const currentTimestamp = Date.now();
      const isTokenExpired = currentTimestamp > expirationTime;
      if (isTokenExpired) {
        setTokenValid(false);
      }
    } else {
      // Token does not exist, handle accordingly
      setTokenValid(false);
    }

  }, [location.search])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const newPassword = formData.password
    const confirmPassword = formData.confirmPassword
    if (formData.password !== formData.confirmPassword) {
      return
    } else {
      // dispatch(resetPassword({ newPassword, confirmPassword ,token,navigate}))
      try {
        const config = {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Set the authorization token in the headers
          },
        };
        setLoad(true)
        // eslint-disable-next-line no-undef
        const response = await axios.post(`${process.env.REACT_APP_LIVE_URL}/auth/reset-password`, { newPassword, confirmPassword }, config);
        if (response.status == 200) {
          dispatch(setUserData(response.data))
          setLoad(false)
          navigate('/login-email')
        }
      } catch (error) {
        setLoad(false)
        toast.error(error.response. data.message,{
          className: 'custom-toast-error',
          progressStyle: { background: '#C53C43' },
        })
      }

    }
  }

  const handleRedirectToLogin = () => {
    navigate('/login');
  };


  useEffect(() => {
    // Check if both password fields are not empty
    setIsFormValid(formData.password.trim() !== '' && formData.confirmPassword.trim() !== '');
  }, [formData]);

  if (!tokenValid) {
    return <div>{UI_CONSTANT.LOGIN.INVALID_OR_EXPIRED}<button onClick={() => navigate('/forgot-password')}>{UI_CONSTANT.LOGIN.LINK}</button></div>
  }

  const handleEnterClick=(e)=>{
    if(e.key==='Enter' || e.keyCode===13){
      handleSubmit(e)
    }
  }

  return (
    <div className='wrapper'>
      <div className='container flex  justify-center align-center'>
        <div className='section logo-section flex justify-center align-center'>
          <div className='container'>
            <img src={appLogo} alt='App Logo' />
          </div>
        </div>
        <div className='section login-section flex justify-center align-center'>
          <div className='container flex flex-column justify-evenly '>
            <WelcomeText title={UI_CONSTANT.LOGIN.WELCOME_TITLE_RESET} message={UI_CONSTANT.LOGIN.WELCOME_MESSAGE_RESET} hideHandIcon />
            <div className='input-wrapper flex flex-column justify-center align-center'>

              <Input
                placeholder='Enter your  New Password'
                icon='password'
                type='password'
                // value={newPassword}
                value={formData.password}
                name="password"
                onChange={handleChange}
                error={errors.password}
              // onChange={(e) => setNewPassword(e.target.value)}
              />
              <div className='pass-forgot flex flex-column justify-end'>
                <Input
                  placeholder='Enter your Confirm Password'
                  icon='password'
                  type='password'
                  name="confirmPassword"
                  onChange={handleChange}
                  value={formData.confirmPassword}
                  errorClass={errors.confirmPassword}
                  onKeyDown={handleEnterClick}
                // value={confirmPassword}
                // onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              {errors.confirmPassword && <div className="error">{errors.confirmPassword}</div>}
            </div>
            <div className='button-wrapper flex flex-column justify-center align-center'>
              <Button onClick={handleSubmit} disabled={!isFormValid || hasErrors} disabledBgColor={'#ee4e56'} customClassName={'otp-login'}>
                <Typography textColor='white' textType='login-button' textWeight='700'>
                  {load ? UI_CONSTANT.LOADING : UI_CONSTANT.LOGIN.RESET_PASSWORD}
                </Typography>
              </Button>

              <Typography textType='login-button' textColor='red' textWeight='600'>
                {UI_CONSTANT.OR}
              </Typography>
              <Button
                onClick={handleRedirectToLogin}
                variant='outlined'
              >
                <Typography textColor='red' textType='login-button' textWeight='700'>
                  {UI_CONSTANT.LOGIN.LOGIN}
                </Typography>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordForm
